import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../../AbstractElements";
import JustifyNav from "./JustifyNav";
import JustifyTabContent from "./JustifyTabContent";
import { AdminProfile, JustifyTabTitle } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { JustifyTabSubTitle } from "../../../../Data/UiKits/Tabs";

const JustifyTab = () => {
  const [basicTab, setBasicTab] = useState("2");
  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={JustifyTabTitle} span={JustifyTabSubTitle} />
        <CardBody>
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2 p-0 border-bottom">
            <P>
              <em className="txt-danger">{AdminProfile}</em>
            </P>
            <JustifyNav basicTab={basicTab} setBasicTab={setBasicTab} />
          </div>
          <CardBody className="px-0 pb-0">
            <JustifyTabContent tabId={basicTab} />
          </CardBody>
        </CardBody>
      </Card>
    </Col>
  );
};
export default JustifyTab;
